<template>
  <main>
    <section class="search container-fluid">
      <div class="row">
        <div class="col-10 offset-1">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="keyowrd"
                  id="keyowrd"
                  class="form-control"
                  v-model="keyword"
                  placeholder="輸入關鍵字..."
                >
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs narrow" role="tablist" id="business-tab">
          <li
            class="nav-item"
            :class="{
              'dropdown': !item.child===false && item.child.length,
              'active' : currentTab==item.key
            }"
            v-for="(item, i) in tree"
            :id="`tree-item-${i}`"
            :key="`tree-item-${i}`"
          >
            <a v-if="!item.child===false && item.child.length"
              data-toggle="dropdown"
              class="nav-link dropdown-toggle"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >{{item.name}}</a>
            <a v-else
              class="nav-link"
              role="button"
              data-toggle="tab"
              :data-item="item.key"
              :data-parent="item.key"
            >{{item.name}}</a>
            <ul class="dropdown-menu" :aria-labelledby="`tree-item-${i}`">
              <li
                class="dropdown-item dropdown-header"
                v-for="(child, j) in item.child"
                :key="`tree-${i}-${j}`"
              >
                <a v-if="!child.child || !child.child.length" role="tab"
                data-toggle="tab"
                :class="{'active': currentInfo===child.key}"
                :data-item="child.key"
                :data-parent="item.key">
                  {{child.name}}
                  <i class="text-green float-right">❯</i>
                </a>
                <h4 v-else class="dropdown-title">{{child.name}}</h4>
                <ul v-if="!child.child===false && child.child.length">
                  <li
                    class="dropdown-item"
                    v-for="(val, k) in child.child"
                    :key="`tree-${i}-${j}-${k}`"
                  >
                    <a role="tab"
                    data-toggle="tab"
                    :class="{'active': currentInfo===val.key}"
                    :data-item="val.key"
                    :data-parent="item.key">
                      {{val.name}}
                      <i class="text-green float-right">❯</i>
                    </a>
                  </li>
                </ul>
              </li>
              <li v-if="item.key==='more'">
                <router-link to="/business/overview" class="link text-underline collapse-item">全部項目
                  <i class="icon-open_as"></i>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="tab-pane active show" v-if="currentInfo==='key-1-1'">
        <div class="row">
          <div class="col-9">
            <h4 class="text-green">保價不足預警通知名單</h4>
            <p>提供同仁追蹤過去與下年度滿期金件數與金額。</p>
          </div>
          <div class="col-3 pt-3">
            <div class="my-3">
              <b class="mr-1">維護單位</b>
              <span>保單給付科</span>
            </div>
            <div>
              <b class="mr-1">聯絡電話</b>
              <span>5978</span>
            </div>
          </div>
        </div>
        <div class="insurance-row row">
          <table id="price-less-table" class="table datatable insurance-green">
            <thead>
              <tr>
                <th>保單號碼</th>
                <th width="120" class="text-right">滿期金額</th>
                <th>滿期日</th>
                <th>要保人</th>
                <th>被保人</th>
                <th>受益人</th>
                <th>指定匯撥帳戶</th>
                <th width="80">受益人確認通知書</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in importantList" :key="`alert-price-less-${i}`">
                <td>{{item.no}}</td>
                <td class="text-right">{{item.money}}</td>
                <td>{{item.date}}</td>
                <td>{{item.target}}</td>
                <td>{{item.client}}</td>
                <td>{{item.beneficiary}}</td>
                <td>{{item.account}}</td>
                <td class="text-center">
                  <a :href="item.file" class="text-link text-orange">
                    <i class="icon-attach i-24"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="tab-pane active show" v-if="currentInfo==='key-1-2'">
        <h4 class="text-green">次約待扣名單</h4>
      </div>
      <div class="tab-pane active show" v-if="currentInfo==='key-1-3'">
        <h4 class="text-green">扣款不成通知單</h4>
      </div>
      <div class="tab-pane active show" v-if="currentInfo==='key-1-4'">
        <h4 class="text-green">保單停效名單</h4>
      </div>
        
      <div class="row py-5" v-if="!currentInfo">
        <div class="col-6 offset-3">
          <h4 class="text-green mb-3 mt-0">行銷名單 TOP 10</h4>
          <table class="table insurance-green">
            <thead>
              <tr>
                <th width="50">排名</th>
                <th>名稱</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in importantList" :key="`billborad-${i}`">
                <td>{{item.no}}</td>
                <td>{{item.name}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { commonMixin } from "../../mixins/common";

const tabTree = [
  {
    key: 'key-1',
    name: "保費訊息",
    child: [
      {key: 'key-1-1', name: "保價不足預警通知名單", url: 0 },
      {key: 'key-1-2', name: "次約待扣名單", url: 1 },
      {key: 'key-1-3', name: "扣款不成通知單", url: 2 },
      {key: 'key-1-4', name: "保單停效名單", url: 3 }
    ]
  },
  {
    key: 'key-2',
    name: "回流再購"
  },
  {
    key: 'key-3',
    name: "VIP"
  },
  {
    key: 'key-4',
    name: "商品/保障"
  },
  {
    key: 'key-5',
    name: "關係建立"
  },
  {
    key: 'key-6',
    name: "整合行銷"
  },
  {
    key: 'more',
    name: "更多",
    child: [
      {
        key: 'key-7-1',
        name: "大項目1",
        child: [
          { key: 'key-7-1-1', name: "小項目名稱1" },
          { key: 'key-7-1-2', name: "小項目名稱2" },
          { key: 'key-7-1-3', name: "小項目名稱3" }
        ]
      },
      {
        key: 'key-7-2',
        name: "大項目1",
        child: [
          { key: 'key-7-2-1', name: "小項目名稱1" },
          { key: 'key-7-2-2', name: "小項目名稱2" },
          { key: 'key-7-2-3', name: "小項目名稱3" }
        ]
      }
    ]
  }
];

const list = {
  'default': [
    { no: 1, name: "投資型保單查詢" },
    { no: 2, name: "信用卡受理進度查詢" },
    { no: 3, name: "指定匯撥帳戶客戶查詢" },
    { no: 4, name: "滿期金目標客戶名單" },
    { no: 5, name: "年金目標客戶名單" },
    { no: 6, name: "產險保戶名單" },
    { no: 7, name: "已購買投資型商品客戶" },
    { no: 8, name: "年金回流進度管控表" },
    { no: 9, name: "實支實付目標客戶" },
    { no: 10, name: "VIP 保戶尊榮服務名單" }
  ],
  'key-1-1': [
    {
      no: "7213193990",
      money: "500,000",
      date: "107/11/06",
      client: "陳怡君",
      target: "陳怡君",
      beneficiary: "陳怡君",
      account: "國泰世華商業銀行成東分行",
      file: ""
    },
    {
      no: "7213193990",
      money: "213,703",
      date: "107/10/09",
      client: "黃小雲",
      target: "黃大偉",
      beneficiary: "黃小雲",
      account: "國泰世華商業銀行成東分行",
      file: ""
    }
  ],
  'key-1-2': [],
  'key-1-3': [],
  'key-1-4': []
};

export default {
  name: "Business",
  mixins: [commonMixin],
  data() {
    return {
      tree: tabTree,
      tables: [],
      currentTab: null,
      currentInfo: null,
      keyword: "",
      importantList: list['default'],
      showMenuMap: false
    };
  },
  methods: {
    setDataTable() {
      if (this.currentInfo === 1) {
        window.$("#price-less-table").DataTable({
          columnDefs: [{ orderable: false, targets: [3, 4, 5, 6, 7] }],
          ordering: true,
          searching: false,
          paging: false
        });
      }
    },
    changeList() {
      this.importantList = list[this.currentInfo];
      setTimeout(() => {
        this.setDataTable();
      }, 1000);
    }
  },
  mounted() {
    window.$('[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      let li = window.$(e.target).closest('.nav-item')
      this.currentTab = e.target.dataset.parent
      this.currentInfo = e.target.dataset.item
      this.changeList()
      if (li.className == "dropdown-item") {
        let link = li.querySelector('a')
        window.$(e.target).attr('aria-selected', false)
        window.$(e.target).removeClass('active show')
        window.$(link).addClass('active show')
      }
    });
  }
};
</script>
